import React, { Component } from 'react';
import CSELogo from './assets/img/cse-logo.png';
import FullScreenPopup from './FullScreenPopup';
import data from './assets/data.json';
import Projects from './Projects'
import Skills from './Skills';
import {Navbar} from 'react-bootstrap';
import {Nav} from 'react-bootstrap';
import {NavItem} from 'react-bootstrap';
import {MenuItem} from 'react-bootstrap';
import {NavDropdown} from 'react-bootstrap';

class RightSide extends React.Component {

	constructor(){
		super();
		console.log(data);
		this.state = {showThesisPopup: false, data: data, selectedThesis: 0, mobileMenuOn: false}
		this.toggle = this.toggle.bind(this);
		//this.handler = this.handler.bind(this);
	}

	handler(){
		this.setState({showThesisPopup: !this.state.showThesisPopup	});
	}

	toggle() {
        this.setState({
            mobileMenuOn: !this.state.mobileMenuOn
        });
    }

	render() {
	return (
		<div className="right-side col-md-7 offset-md-5" >
			{<FullScreenPopup handler = {this.handler.bind(this)} selectedEducation= {this.state.data[0].education[this.state.selectedThesis]} visible={this.state.showThesisPopup}/> }
			{console.log(this.state.data[0].education[this.state.selectedThesis])}
	




<nav class="navbar navbar-expand-lg navbar-light bg-light menu">
<a class="navbar-brand logo-as-name" href="#"><span className="logo-letter">T</span><span className="logo-letter">P</span>
<span> Thanos Pappas</span></a>
  <button class="navbar-toggler float-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" 
   onClick={this.toggle}>
    <span class="navbar-toggler-icon"></span>
  </button>

  <div className={"collapse navbar-collapse " +  (this.state.mobileMenuOn ? "show" : "")} id="navbarSupportedContent">
     <ul className="navbar-nav mr-auto menu-items"> 
      <li className="animated bounceIn nav-item"> <a href="#education" onClick={this.toggle}>
      Education</a>
	</li>
	<li className="animated bounceIn nav-item hide-mobile">//</li>
    <li className="animated bounceIn nav-item ">
      <a href="#work" onClick={this.toggle}>Work Experience</a>
      </li>
      <li className="animated bounceIn nav-item hide-mobile">//</li>
    <li className="animated bounceIn nav-item">
      <a href="#skills-sec" onClick={this.toggle}>Skills</a>
      </li>
      <li className="animated bounceIn nav-item hide-mobile">//</li>
    <li className="animated bounceIn nav-item">
     <a href="#projects" onClick={this.toggle}> Projects</a>
      </li>
     
    </ul>

  </div>
</nav>



			<div className="resume-content col-md-12">
				<div id="education" className="education">
					<div className="ed-title">
						<h2>Education</h2>
					</div>
					<div className="education-item">
						{this.state.data[0].education.map((educationInfo, index) => {
							return (
								<div className="qa-message-list" id="wallmessages">
									<div className="message-item" id="m16">
										<div className="row">
											<div className="col-md-10">
												<h5>{educationInfo.title}</h5>
												{ educationInfo.Field && <div><span>Field: {educationInfo.Field}</span></div>}
												{ educationInfo.University &&<div><span>{educationInfo.University}</span></div>}
												{ educationInfo.Date &&<div><span>{educationInfo.Date}</span></div>}
												{ educationInfo.Degree &&<div><span>Degree: {educationInfo.Degree}</span></div>}
												{ educationInfo.Thesis &&<div><span>Thesis: <a href="#" onClick={this.openThesis.bind(this,index)}>{educationInfo.Thesis}</a>
												</span></div>}
											</div>
											<div className="col-md-2">
												{ educationInfo.hasPhoto && <img className="img-fluid" src={CSELogo}/>}
											</div>
										</div>
									</div>
								</div>
							)
						})}
					</div>
				</div>	

				<div id="work" className="work-experience">
					<div className="ed-title">
						<h2>Work Experience</h2>
					</div>

					<div className="row work-experience-item">
					<div className="qa-message-list" id="wallmessages">
					<div className="message-item" id="m16">
						<div class="row">
							<div className="col-md-9">
								<h4>Full Stack Developer</h4>
								<h5>Freelancer</h5>
							</div>
							<div className="col-md-3">
							  Oct 2014 - July 2018
							</div>
						</div>
						<p>I worked on various projects and I used a lot of different technologies during this period. 
						Some of the techonologies I used are: 
						Wordpress websites, Woocommerce based e-shops, Shopify, Email Marketing Campaigns, 
						AngularJS web apps, nodejs apps, ETL, Web site optimization for digital marketing.</p>
						<ul>
							<li>CMS and Ecommerce based websites: Wordpress, Shopify, Woocommerce</li>
							<li>Custom web applications using technologies such as NodeJS, AngularJS, ReactJS, ExpressJS, PHP</li>
							<li>Data manipulations and analytics: ETL, Python</li>
							<li>Java Applications</li>
						</ul>
						</div>
						</div>
					</div>

					<div className="row work-experience-item">
					<div className="qa-message-list ta" id="wallmessages">
					<div className="message-item " id="m16">
						<div class="row">
							<div className="col-md-8">
								<h4>Teaching Assistant</h4>
								<h5>Sostware Engineering & Operating Systems</h5>
							</div>
							<div className="col-md-4">
							  <span className="float-right">Oct 2015 - Feb 2017</span>
							</div>
						</div>

						<div className="row">
								<div className="col-md-6">
									<b>Software Engineering</b>
									<ul>
										<li>UML</li>
										<li>Design Patterns</li>
										<li>Java</li>
									</ul>
								</div>
								<div className="col-md-6">
									<b>Operating Systems</b>
									 <ul>
										<li>Threads</li>
										<li>Mutexes</li>
										<li>Minix</li>
									</ul>
								</div>
							</div> 
						</div>
						</div>
					</div>
					
				</div>

				<div id="skills-sec" className="skills">
					<Skills/>
				</div>
				<div id="projects">
					<Projects/>
				</div>
			</div>
			
		</div>
		);
	}

	renderEducation(){
		for (var i = 0; i < data.education.length; i++){
			<div className="qa-message-list" id="wallmessages">
				<div className="message-item" id="m16">
					<div className="row">
						<div className="col-md-10">
							<h5>data.education[i].title</h5>
							<span>Field: data.education[i].Field</span><br/>
							<span>data.education[i].University</span><br/>
							<span>data.education[i].Date</span><br/>
							<span>Degree: data.education[i].Degree</span><br/>
							<span>Thesis: <a href="#" onClick={this.openThesis.bind(this)}>data.education[i].Thesis</a>
							</span>
						</div>
						<div className="col-md-2">
							<img className="img-fluid" src={CSELogo}/>
						</div>
					</div>
				</div>
			</div>
		}

	}

  openThesis(e, index){
  	this.state.showThesisPopup = !this.state.showThesisPopup;
  	this.setState({selectedThesis: e});
  }
}
export default RightSide;


// WEBPACK FOOTER //
// ./src/RightSide.js